<!-- 公司介绍 -->
<template>
  <div>
    <div id="cont">
      <div class="cont">
        <div class="cont_l">
          <div class="cont_l_01">
            <div class="cont_l_02">
              <img :src="images.js_03">
            </div>
            <div class="cont_l_03">
              <ul class="lit01">
                <li class="lit01_c">
                  <router-link to="/profileen/gsjjen" class="lit01_b">{{text.profile1}}</router-link>
                  <router-link to="/profileen/alxwen" class="lit01_b">{{text.profile2}}</router-link>
                </li>
              </ul>
            </div>
            <div class="cont_l_04"></div>
          </div>
        </div>
        <div class="cont_r">
          <div class="cont_r_t">
            <div class="cont_r_t01">
              <span>{{text.profile3}}</span>
              <span>：</span>
              <span>{{text.profile4}}</span>
              <span>-</span>
              <span>{{text.profile5}}</span>
              <span>-</span>
              <span>{{this.$route.path == '/profileen/gsjjen' ? text.profile1 : text.profile2}}</span>
            </div>
          </div>
          <div class="cont_r_b">
            <div id="rightdiv">
              <router-view></router-view>
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        js_03: require("../../../assets/img/en/js_03.jpg")
      },
      text: {
        profile1: "ABOUT CMC",
        profile2: "CASE & NEWS",
        profile3: "",
        profile4: "Home",
        profile5: "ABOUT"
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/profile/profile.vue